import React from "react";
import { motion } from "framer-motion";
import classes from "./TitleLoading.module.css";

const TitleLoading = () => {
  return (
    <motion.div
      className={classes.skeleton}
      initial={{
        background:
          "linear-gradient(45deg,hsl(0deg 0% 14%) 0%,hsl(0deg 0% 14%) 20%,hsl(0deg 0% 14%) 29%,hsl(0deg 0% 14%) 36%,hsl(0deg 0% 14%) 43%,hsl(0deg 0% 14%) 50%,hsl(228deg 3% 12%) 57%,hsl(228deg 5% 11%) 64%,hsl(228deg 8% 9%) 71%,hsl(228deg 11% 8%) 80%,hsl(228deg 14% 7%) 100%)",
      }}
      animate={{
        background: [
          "linear-gradient(45deg, hsl(228deg 14% 7%) 0%, hsl(228deg 11% 8%) 20%, hsl(228deg 8% 9%) 29%, hsl(228deg 5% 11%) 36%, hsl(228deg 3% 12%) 43%, hsl(0deg 0% 14%) 50%, hsl(228deg 3% 12%) 57%, hsl(228deg 5% 11%) 64%, hsl(228deg 8% 9%) 71%, hsl(228deg 11% 8%) 80%, hsl(228deg 14% 7%) 100%)",
          "linear-gradient(45deg,hsl(0deg 0% 14%) 0%,hsl(0deg 0% 14%) 20%,hsl(0deg 0% 14%) 29%,hsl(0deg 0% 14%) 36%,hsl(0deg 0% 14%) 43%,hsl(0deg 0% 14%) 50%,hsl(228deg 3% 12%) 57%,hsl(228deg 5% 11%) 64%,hsl(228deg 8% 9%) 71%,hsl(228deg 11% 8%) 80%,hsl(228deg 14% 7%) 100%)",
          "linear-gradient(45deg,hsl(228deg 14% 7%) 0%,hsl(228deg 11% 8%) 20%,hsl(228deg 8% 9%) 29%,hsl(228deg 5% 11%) 36%,hsl(228deg 3% 12%) 43%,hsl(0deg 0% 14%) 50%,hsl(0deg 0% 14%) 57%,hsl(0deg 0% 14%) 64%,hsl(0deg 0% 14%) 71%,hsl(0deg 0% 14%) 80%,hsl(0deg 0% 14%) 100%)",
        ],
      }}
      transition={{
        duration: 2,
        repeatType: "mirror",
        repeat: Infinity,
        ease: "linear",
      }}
    ></motion.div>
  );
};

export default TitleLoading;
